import { takeLatest, all, put, call } from 'redux-saga/effects'
import * as calls from './calls'
import * as reducerActions from '../../reducers/LocalidadEntregaReducer/actions'
import * as Notification from '../../components/Common/notification'
import * as layoutActions from '../../reducers/LayoutReducer/actions'
import { Notifications } from '@material-ui/icons'

function* genGetLocalidadesEntregaActivas() {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando localidades de entrega' }));

        let localidades = yield call(calls.GetLocalidadesEntregaActivas);
        yield put(reducerActions.setLocalidadesEntrega(localidades));
    } catch (error) {
        if (error.message) {
            console.error('Error en la petición de localidades entrega activas', error);
            Notifications.showError(error.message);
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genGetLocalidadEntrega(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando localidad de entrega' }));

        let localidad = yield call(calls.GetLocalidadEntrega, e.payload.idLocalidadEntrega);
        yield put(reducerActions.setLocalidadEntrega(localidad));
    } catch (error) {
        if (error.message) {
            console.error('Error en la petición de localidad entrega por ID', error);
            Notifications.showError(error.message);
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* defaultSaga() {
    yield all([
        takeLatest(reducerActions.SAGA_GET_LOCALIDADES_ENTREGA_ACTIVAS, genGetLocalidadesEntregaActivas),
        takeLatest(reducerActions.SAGA_GET_LOCALIDAD_ENTREGA, genGetLocalidadEntrega),
    ]);
}

export const sagas = [
    defaultSaga,
];

